import { render, staticRenderFns } from "./SchoolCurriculumInformation.vue?vue&type=template&id=04f67d2e&scoped=true&lang=pug&"
import script from "./SchoolCurriculumInformation.vue?vue&type=script&lang=ts&"
export * from "./SchoolCurriculumInformation.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolCurriculumInformation.vue?vue&type=style&index=0&id=04f67d2e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f67d2e",
  null
  
)

export default component.exports